/**
 * Data for list of skills
 */

const skillsetList = ['web developer', 'web designer', 'generalist', 'dev ops', 'email developer', 'information architect', 'usability developer', 'UX developer', 'prototype developer'];

export default skillsetList;